import React from 'react';
import ContractList from '../components/contracts/ContractList';

const ContractsPage = () => {
  return (
    <div className="h-full">
      <ContractList />
    </div>
  );
};

export default ContractsPage;